<template>
  <div>
    <!--policy START-->

    <p class="modal">Rare Recruitment Ltd ("we") are committed are committed to providing a website that is accessible for all people, regardless of technology or ability.</p>

    <p class="modal">We strive to comply with the Web Content Accessibility Guidelines (WCAG) 2.1 level AA standards where we can, and we are actively taking steps to further enhance the accessibility of our website to meet or exceed applicable standards.</p>

    <p class="modal">We regularly test our website for accessibility using a variety of methods, including manual testing by external consultants. We also welcome feedback from our users on how we can improve the accessibility of our website.</p>

    <p class="modal">If you have any questions or concerns about the accessibility of our website, please contact us at <a href="mailto:support@candidats.io" target="_blank">support@candidats.io</a>.</p>

    <p class="modal">This website has been designed to work on all devices including smartphones, tablets, laptops and desktops, and all modern browsers.</p>
  </div>
</template>

<script>
export default {
  name: 'RareLegalAccessibilityPolicy',
  methods: {
    openManageCookies() {
      this.$store.commit('updateShowBannerOnClose', false);
      this.$emit('openManageCookies', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  table {
    table-layout: fixed;
    width: 100%;
    border: 1px solid black;
    margin-top: 72px;
  }

  tr {
    vertical-align: top;
  }

  td {
    border: 1px solid black;
    padding: 10px;
    word-break: break-word;
  }

</style>



// WEBPACK FOOTER //
// src/pages/legal/components/RareLegalAccessibilityPolicy.vue